import {gql} from "graphql-tag";
import {responseField} from "../../../base.graphql";


const translationsearchTermFields = `
id
en
sw
searchTerm
`


export const GET_ALL_TRANSLATIONS_searchTermS = gql`
query GetTranslations {
  getTranslations {
    response {
      ${responseField}
    }
    data {
      ${translationsearchTermFields}
    }
  }
}
`

export const SAVE_TRANSLATIONS_MUTATION = gql`
mutation SaveTranslationsMutation($input: [TranslationInput]) {
  saveTranslationsMutation(input: $input) {
    response {
      ${responseField}
    }
    data {
      ${translationsearchTermFields}
    }
  }
}
`

export const REMOVE_TRANSLATIONS_MUTATION = gql`
mutation RemoveTranslationsMutation($searchTerm: String) {
  removeTranslationsMutation(searchTerm: $searchTerm) {
    response {
      ${responseField}
    }
  }
}
`
